import { render, staticRenderFns } from "./DevBpbjWarehousingRecordModal.vue?vue&type=template&id=4fe23679&"
import script from "./DevBpbjWarehousingRecordModal.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports